import { WEB3MODAL_PROJECT_ID } from '~/config'
import { CHAINS } from '~/config/connection'

import { createAppKit } from '@reown/appkit/vue'
import { EthersAdapter } from '@reown/appkit-adapter-ethers'
import { defineChain } from '@reown/appkit/networks'

export function useConnectModal() {
  const isProd = import.meta.env.MODE === 'production'

  function initWallet() {
    // 1. Get projectId at https://cloud.walletconnect.com
    const projectId = WEB3MODAL_PROJECT_ID

    // 3. Create modal
    const metadata = {
      name: 'Jpool-JWater',
      description: 'Staking',
      url: 'https://mywebsite.com',
      icons: ['https://avatars.mywebsite.com/'],
    }

    const chainsByMode = isProd ? CHAINS.filter(ch => ch.name === 'Waterfall') : CHAINS
    const customNetworks = chainsByMode.map((chain) =>
      defineChain({
        id: chain.chainId,
        caipNetworkId: `eip155:${chain.chainId}`,
        chainNamespace: 'eip155',
        name: chain.name,
        nativeCurrency: {
          decimals: 18,
          name: chain.currency,
          symbol: chain.currency,
        },
        rpcUrls: {
          default: {
            http: [chain.rpcUrl],
          },
        },
        blockExplorers: {
          default: { name: 'Explorer', url: chain.explorerUrl },
        },
        contracts: {},
      })
    );

    createAppKit({
      adapters: [new EthersAdapter()],
      // @ts-expect-error...
      networks: customNetworks,
      metadata,
      projectId,
    })
  }

  return {
    initWallet,
  }
}
